<template>
    <div class="o-topbar">
        <div class="o-topbar__title">
            <div class="o-topbar__trigger margin-r-16" @click="openSidebar()">
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M20.0513 16c.522 0 .949.427.949.949v.102c0 .522-.427.949-.949.949H3.9483c-.522 0-.948-.427-.948-.949v-.102c0-.522.426-.949.948-.949Zm0-5c.522 0 .949.427.949.949v.102c0 .522-.427.949-.949.949H3.9483c-.522 0-.948-.427-.948-.949v-.102c0-.522.426-.949.948-.949Zm0-5c.522 0 .949.427.949.949v.102c0 .522-.427.949-.949.949H3.9483c-.522 0-.948-.427-.948-.949v-.102c0-.522.426-.949.948-.949Z" id="menu"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#menu"/></svg>
            </div>
            <h2 class="no-margin">{{title}}</h2>
        </div>

        <div class="o-topbar__action" v-if="button">
            <template v-if="button.event">
                <button type="button" class="c-btn no-margin o-topbar__new-request" @click="trigger(button.event)">
                    <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M19 11h-6V5c0-.553-.448-1-1-1s-1 .447-1 1v6H5c-.552 0-1 .447-1 1 0 .553.448 1 1 1h6v6c0 .553.448 1 1 1s1-.447 1-1v-6h6c.552 0 1-.447 1-1 0-.553-.448-1-1-1" id="plus"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#plus"/></svg>
                    <span>{{button.text}}</span>
                </button>
            </template>
            <template v-else-if="button.href">
                <a class="c-btn no-margin o-topbar__new-request" :href="button.href + querystring" :target="button.target">
                    <span>{{button.text}}</span>
                </a>
            </template>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    methods: {
        trigger(event) {
            this.$store.dispatch('listener/emit', event);
        },
        openSidebar () {
            this.$root.$emit('open-sidebar');
        }
    },
    computed: {
        button() {
            return typeof this.$route.meta.button == 'function' ?
                    this.$route.meta.button(this.$route, this.user) : undefined;
        },
        title() {
            return typeof this.$route.meta.title == 'function' ?
                    this.$route.meta.title(this.$route, this.user) : this.$route.meta.title;
        },
        querystring() {
            let output = [];

            if ( this.applied ) {

                if ( this.applied.search ) {
                    output.push(encodeURIComponent('search')+ "=" + encodeURIComponent(this.applied.search));
                }

                if ( this.applied.filters &&  Array.isArray(this.applied.filters) ) {
                    this.applied.filters.forEach( (f, index) => {
                        output.push(encodeURIComponent('filters['+ index +'][name]')+ "=" + encodeURIComponent(f.name));
                        output.push(encodeURIComponent('filters['+ index +'][value]')+ "=" + encodeURIComponent(f.value));
                    });
                }
            }

            return ( output.length > 0 ) ? '?' + output.join('&') : '';
        },
        ...mapState({
            user: (state) => state.user.data,
            applied: (state) => state.user.filters.declaration
        })
    }
}
</script>
